<template>
  <modal name="staffSelection" :clickToClose="false">
    <div v-if="companion" class="image-container max-w-screen-sm">
        <img class="m-auto mb-8 w-64" alt='Companion App' src='../../assets/images/companion-logo.png'>
        <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
      </div>
      <div v-else>
        <div v-if="this.profile.Language_ID === 1 || !this.profile.Language_ID" class="image-container max-w-screen-sm">
          <img class="m-auto mb-8 w-64" alt='Connections App' src='../../assets/images/logo.png'>
          <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
        </div>
        <div v-else class="image-container max-w-screen-sm">
          <img class="m-auto mb-8 w-64" alt='Conexiones App' src='../../assets/images/conexiones.png'>
          <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
        </div>
      </div>
    <div class="content">
      <p class="mb-4 font-bold text-base">Enrollment Form for Inviting Individuals to the {{companion ? 'Companion' : 'Connections'}} App</p>
      <p class="mb-4">Select who you are: </p>
      <StaffSelectionDropdown :staffList="profile.StaffArray" @selectedStaff="selectedStaffReceived" :filteredStaffList="profile.StaffArray">
      </StaffSelectionDropdown>
      <button class="w-24" :disabled="selectedStaff === null" :class="{compbutton: companion}" @click="closeModal">Next</button>
      <div class="loading" v-if="loading">
        <LoadingUI />
      </div>
    </div>
  </modal>
</template>
<script>

import LoadingUI from '../LoadingUI.vue'
import StaffSelectionDropdown from '../StaffSelectionDropdown.vue';

export default {
  name: 'StaffSelectionModal',
  components: { // imported components
    LoadingUI,
    StaffSelectionDropdown
  },
  props: { // props passed into component
    profile: Object,
    companion: Boolean
  },
  data() { // component props
    return {
      loading: false,
      selectedStaff: null
    }
  },
  created() { },
  mounted() { },
  methods: { // component functions
    closeModal() {
      if (this.selectedStaff) {
        //cache the selected staff
        sessionStorage.setItem("staffSelectedCached", JSON.stringify(this.selectedStaff));
      }
      this.$emit('close-modal', this.selectedStaff);
      this.$modal.hide('staffSelection');
    },
    selectedStaffReceived(data) {
      this.selectedStaff = data;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  text-align: center;
  width: 400px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  height: 40px;
  font-size: 14px;
  border: none;
  padding: 6px 12px;
  border-radius: 40px;
  color: white;
  background: #750097;
}

.compbutton {
  background: #2c6759;
}

button.send {
  border-radius: 4px;
}

button:disabled,
.compbutton:disabled {
  color: white;
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.image-container {
  display: inline-flex;
  justify-content: center;
  max-width: 640px;
  flex-wrap: wrap;
}

.light-blue {
  color: #750097;
}
.green{
  color:#2c6759;
}
@media only screen and (max-width: 767px) {
  .content {
  text-align: center;
  width: auto;
}
}
</style>

<!-- Not "scoped" to style modal -->
<style>
.vm--container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vm--overlay {
  background: rgba(8, 17, 53, 0.38) !important;
}

.vm--modal {
  text-align: center;
  border-radius: 4px !important;
  background: #ffffff;
  padding: 20px;
  height: auto !important;
  width: auto !important;
  max-width: 600px;
  top: auto !important;
  left: auto !important;
  margin: 15px;
}
</style>